import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/facebook-constant";

export {
    addAdSets,
    saveSingleAdSet,
    addSingleAdSet,
    updateSingleAdSet,
    getSingleAdSet,
    getAllAdSets,
    searchAdSets,
    searchAdSetsWithSearchCriteria,
    prepareAdSetsList
}

const collectionName = 'facebook-ad-sets';
const collectionReference = collection(fireStoreDB, collectionName);

const addAdSets = (adSets) => {
    return Promise.map(adSets, async adSet => {
        await addSingleAdSet(adSet);
    });
}

const saveSingleAdSet = (adSet) => {
    const documentReference = doc(fireStoreDB, collectionName, adSet.id);

    adSet.updatedAt = new Date();
    if (!adSet.createdAt) {
        adSet.createdAt = adSet.updatedAt;
    }

    return setDoc(documentReference, adSet, {merge: true});
}


const addSingleAdSet = (adSet) => {
    adSet.createdAt = new Date();
    adSet.updatedAt = adSet.createdAt;
    return addDoc(collectionReference, adSet);
}

const updateSingleAdSet = (adSet) => {
    const documentReference = doc(fireStoreDB, collectionName, adSet.id);
    adSet.updatedAt = new Date();
    return setDoc(documentReference, adSet);
}

const getSingleAdSet = async (adSetId) => {
    const documentReference = doc(fireStoreDB, collectionName, adSetId);
    const adSetDoc = await getDoc(documentReference);
    return prepareSingleAdSet(adSetDoc);
}

const getAllAdSets = async () => {
    let searchQuery = query(collectionReference);
    const adSetsResult = await getDocs(searchQuery);
    return prepareAdSetsList(adSetsResult);
}

const searchAdSets = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const adSetResult = await getDocs(searchQuery);
    return prepareAdSetsList(adSetResult);
}

const searchAdSetsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchAdSetsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const adSetResult = await getDocs(searchQuery);
    return prepareAdSetsList(adSetResult);
}

const prepareAdSetsList = (adSetResult) => {
    const adSetsList = [];

    _.forEach(adSetResult.docs, adSetDoc => {
        adSetsList.push(prepareSingleAdSet(adSetDoc));
    });

    return adSetsList;
}


const prepareSingleAdSet = (adSetDoc) => {
    const adSet = adSetDoc.data();
    adSet.id = adSetDoc.id;
    return adSet;
}
